module.exports = __webpack_public_path__ + "img/request-semipublic.7bf55a13.svg";